if (!customElements.get('pickup-availability')) {
  class PickupAvailability extends HTMLElement {
    constructor() {
      super();

      this.refreshHandler = this.handleRefreshBtnClick.bind(this);

      // Find the unavailable message template
      const template = this.querySelector('template');
      if (template) {
        this.unavailableHtml = template.content.firstElementChild.cloneNode(true);
      } else {
        console.warn("Pickup Availability: No template found.");
      }

      this.getAvailability(this.dataset.variantId);
      this.observeVariantChanges();
    }

    observeVariantChanges() {
      const variantSelector = document.querySelector('[name="id"]');
      if (!variantSelector) {
        console.warn("Pickup Availability: No variant selector found.");
        return;
      }

      variantSelector.addEventListener('change', (event) => {
        const newVariantId = event.target.value;
        if (newVariantId) {
          this.dataset.variantId = newVariantId;
          this.getAvailability(newVariantId);
        }
      });
    }

    handleRefreshBtnClick() {
      this.getAvailability(this.dataset.variantId);
    }

    async getAvailability(variantId) {
      let { rootUrl } = this.dataset;
      if (!rootUrl.endsWith('/')) rootUrl = `${rootUrl}/`;

      try {
        // Instead of hiding, we set visibility so the layout doesn't shift
        this.classList.add('loading');

        const response = await fetch(`${rootUrl}variants/${variantId}/?section_id=pickup-availability`);
        if (!response.ok) throw new Error(response.status);

        const tmpl = document.createElement('template');
        tmpl.innerHTML = await response.text();

        this.updatePickupInfo(tmpl.content.querySelector('.shopify-section'));
      } catch (error) {
        console.error("Error fetching pickup availability:", error);
        this.renderUnavailableMsg();
      } finally {
        // Restore visibility smoothly
        this.classList.remove('loading');
      }
    }

    updatePickupInfo(sectionHtml) {
      if (!sectionHtml || !sectionHtml.querySelector('.pickup-status')) {
        this.renderUnavailableMsg();
        return;
      }

      this.setAttribute('available', '');

      const existingContent = this.querySelector('.pickup-status');
      const newContent = sectionHtml.querySelector('.pickup-status');

      if (existingContent) {
        // Instead of replacing the element, update the text content directly
        existingContent.innerHTML = newContent.innerHTML;
      } else {
        this.appendChild(newContent);
      }

      const drawer = document.querySelector('.js-pickup-drawer');
      if (drawer) drawer.remove();
      document.body.appendChild(sectionHtml.querySelector('.js-pickup-drawer'));

      const showDetailsBtn = this.querySelector('.js-show-pickup-info');
      if (showDetailsBtn) {
        showDetailsBtn.addEventListener('click', () => {
          document.querySelector('.js-pickup-drawer').open(showDetailsBtn);
        });
      }
    }

    renderUnavailableMsg() {
      let existingMessage = this.querySelector('.pickup-status');
      if (!existingMessage) {
        if (this.unavailableHtml) {
          this.appendChild(this.unavailableHtml);
          const refreshBtn = this.querySelector('.js-refresh');
          if (refreshBtn) refreshBtn.addEventListener('click', this.refreshHandler);
        } else {
          console.warn("Pickup Availability: Unavailable message template missing.");
        }
      }
    }
  }

  customElements.define('pickup-availability', PickupAvailability);
}
